import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import logo from '../images/grips-logo.svg';
import { LanguageContext } from '../contexts/LanguageContext';
import { Link } from 'react-router-dom';

const Footer = () => {
    const { language } = React.useContext(LanguageContext);
    return (
        <div className='bg-body-tertiary footer-mt'>
            <Container fluid className="grips-bg text-white text-center py-3">
                <Row className='justify-content-center'>
                    <Col className='col-4'>
                        <img src={logo} alt="Logo" className="d-inline-block align-top img-fluid w-25" />
                    </Col>
                </Row>
                <Row className="mt-3">
                    <Col>
                        <Link to="/kontakt" className="text-white mx-2 fs-6 text-decoration-none">
                            {language === 'de' ? 'KONTAKT' : 'CONTACT'}
                        </Link>
                        <Link to="/impressum" className="text-white mx-2 fs-6 text-decoration-none">
                            {language === 'de' ? 'IMPRESSUM' : 'IMPRINT'}
                        </Link>
                        <Link to="/datenschutz" className="text-white mx-2 fs-6 text-decoration-none">
                            {language === 'de' ? 'DATENSCHUTZ' : 'DATA PROTECTION'}
                        </Link>
                    </Col>
                </Row>
            </Container>
            <Container fluid className="bg-white text-black text-center py-3">
                <Row>
                    <Col>
                        © 2020- meltshop365 by GRIPS Industrial IT Solutions GmbH
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default Footer;